import { Routes } from '@angular/router';
import { authGuard } from './auth.guard';
import { gtmFreeGuard, loadGtmGuard } from './gtm.guard';
import { creatorStepGuard } from './creator-step.guard';

export const routes: Routes = [
  {
    path: 'creator',
    loadComponent: () =>
      import('./creator/creator-layout/creator-layout.component').then(
        (c) => c.CreatorLayoutComponent,
      ),
    canActivate: [loadGtmGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./creator/creator-home/creator-home.component').then(
            (c) => c.CreatorHomeComponent,
          ),
        title: 'Wybór lokalizacji',
      },
      {
        path: 'storage',
        canActivate: [creatorStepGuard('storage')],
        loadComponent: () =>
          import('./creator/storage/storage.component').then(
            (c) => c.StorageComponent,
          ),
        title: 'Wybór magazynu',
      },
      {
        path: 'period',
        canActivate: [creatorStepGuard('period')],
        loadComponent: () =>
          import('./creator/period/period.component').then(
            (c) => c.PeriodComponent,
          ),
        title: 'Okres najmu i cena',
      },
      {
        path: 'orderForm',
        canActivate: [creatorStepGuard('orderForm')],
        loadComponent: () =>
          import('./creator/order-form/order-form.component').then(
            (c) => c.OrderFormComponent,
          ),
        title: 'Formularz rezerwacji',
      },
      {
        path: 'payment',
        loadComponent: () =>
          import('./creator/order-payment/order-payment.component').then(
            (c) => c.OrderPaymentComponent,
          ),
        title: 'Płatność',
      },
      {
        path: 'orderSummary/:id',
        pathMatch: 'prefix',
        loadComponent: () =>
          import('./creator/order-summary/order-summary.component').then(
            (c) => c.OrderSummaryComponent,
          ),
        title: 'Podsumowanie rezerwacji',
      },
    ],
  },
  {
    path: 'panel',
    loadComponent: () =>
      import('./panel/panel-layout/panel-layout.component').then(
        (c) => c.PanelLayoutComponent,
      ),
    data: {},
    canActivate: [gtmFreeGuard, authGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./panel/panel-home/panel-home.component').then(
            (c) => c.PanelHomeComponent,
          ),
        data: { breadcrumb: 'Pulpit' },
        title: 'Panel - Pulpit',
      },
      {
        path: 'clients',
        data: { breadcrumb: 'Klienci' },
        title: 'Panel - Klienci',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./panel/clients/clients.component').then(
                (c) => c.ClientsComponent,
              ),
            data: { breadcrumb: null },
          },
          {
            path: 'details/:id',
            loadComponent: () =>
              import(
                './panel/clients/client-details/client-details.component'
              ).then((c) => c.ClientDetailsComponent),
            data: { breadcrumb: 'Szczegóły klienta (ID: :id)' },
            title: 'Panel - Szczegóły klienta',
          },
        ],
      },
      {
        path: 'locations',
        data: { breadcrumb: 'Lokalizacje' },
        title: 'Panel - Lokalizacje',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./panel/locations/locations.component').then(
                (c) => c.LocationsComponent,
              ),
            data: { breadcrumb: null },
          },
          {
            path: 'details/:id',
            loadComponent: () =>
              import(
                './panel/locations/location-details/location-details.component'
              ).then((c) => c.LocationDetailsComponent),
            data: { breadcrumb: 'Szczegóły lokalizacji (ID: :id)' },
          },
        ],
      },
      {
        path: 'rents',
        data: { breadcrumb: 'Wynajmy' },
        title: 'Panel - Wynajmy',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./panel/rents/rents.component').then(
                (c) => c.RentsComponent,
              ),
            data: { breadcrumb: null },
          },
          {
            path: 'details/:id',
            loadComponent: () =>
              import('./panel/rents/rent-details/rent-details.component').then(
                (c) => c.RentDetailsComponent,
              ),
            data: { breadcrumb: 'Szczegóły wynajmu (ID: :id)' },
            title: 'Panel - Szczegóły wynajmu',
          },
        ],
      },
      {
        path: 'reports',
        data: { breadcrumb: 'Raporty' },
        title: 'Panel - Raporty',
        children: [
          {
            path: 'schedule',
            loadComponent: () =>
              import(
                './panel/rents/rent-schedule/rent-schedule.component'
                ).then((c) => c.RentScheduleComponent),
            data: { breadcrumb: 'Płatności interaktywne' },
            title: 'Panel - Raport - Płatności interaktywne',
          },
        ],
      },
      {
        path: 'reservations',
        data: { breadcrumb: 'Rezerwacje' },
        title: 'Panel - Rezerwacje',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./panel/reservations/reservations.component').then(
                (c) => c.ReservationsComponent,
              ),
            data: { breadcrumb: null },
          },
          {
            path: 'details/:id',
            loadComponent: () =>
              import(
                './panel/reservations/reservation-details/reservation-details.component'
              ).then((c) => c.ReservationDetailsComponent),
            data: { breadcrumb: 'Szczegóły rezerwacji (ID: :id)' },
            title: 'Panel - Szczegóły rezerwacji',
          },
        ],
      },
      {
        path: 'storages',
        data: { breadcrumb: 'Rodzaje magazynów' },
        title: 'Panel - Rodzaje magazynów',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./panel/storages/storages.component').then(
                (c) => c.StoragesComponent,
              ),
            data: { breadcrumb: null },
          },
          {
            path: 'details/:id',
            loadComponent: () =>
              import(
                './panel/storages/storage-details/storage-details.component'
              ).then((c) => c.StorageDetailsComponent),
            data: { breadcrumb: 'Szczegóły rodzaju magazynu (ID: :id)' },
          },
        ],
      },
      {
        path: 'storageContainers',
        data: { breadcrumb: 'Magazyny' },
        title: 'Panel - Magazyny',
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './panel/storageContainers/storage-containers.component'
              ).then((c) => c.StorageContainersComponent),
            data: { breadcrumb: null },
          },
          {
            path: 'details/:id',
            loadComponent: () =>
              import(
                './panel/storageContainers/storage-container-details/storage-container-details.component'
              ).then((c) => c.StorageContainerDetailsComponent),
            data: { breadcrumb: 'Szczegóły magazynu (ID: :id)' },
          },
        ],
      },
    ],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./shared/login/login.component').then((c) => c.LoginComponent),
    canActivate: [gtmFreeGuard],
    title: 'Logowanie',
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./shared/reset-password/reset-password.component').then(
        (c) => c.ResetPasswordComponent,
      ),
    canActivate: [gtmFreeGuard],
    title: 'Resetowanie hasła',
  },
  { path: '', redirectTo: '/creator', pathMatch: 'prefix' },
];
